
// src/connects/unread-diaries-card.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state, ownProps)=> {
  return {
    unreadCount: ownProps.group && parseInt(ownProps.group.unreadCount),
    newItems: state.diaries.newItems
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    showUnreadTimeline: ()=> {
      if (ownProps.group) {
        dispatch(actions.openRightSidePage('unread_timeline', { group_id: ownProps.group.group_id }))
        setTimeout(()=> dispatch(actions.mergeNewDiaries(ownProps.group.group_id)), 3000)
      } else
        dispatch(actions.mergeNewDiaries('home'))
    },

    flushUnreads: ()=> {
      dispatch(actions.mergeNewDiaries())
      dispatch(actions.closeRightSidePage(true))
      if (ownProps.group) {
        dispatch(actions.flushUnreadDiaries(ownProps.group.group_id))
        setTimeout(()=> {
          dispatch(actions.fetchDiaries(ownProps.group.group_id, 0))
          dispatch(actions.fetchGroupUnreadCount(ownProps.group.group_id))
        }, 500)
      }
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/unread-diaries-card.js